<script setup lang="ts">
import type { EventModel } from '@/types/models/EventModel'
import { DividerItem, StackLayout } from '@rfc/rfc-components-library'
import { EOrientation } from '@rfc/rfc-components-library/types'
import { useWindowSize } from '@vueuse/core'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import type { CheckpointModel } from '../../../../types/models/CheckpointModel'
import CheckpointStatTypography from './CheckpointStatTypography.vue'

const store = useStore()

type Props = {
    checkpoints?: CheckpointModel[]
    eventData?: EventModel
}
const props = defineProps<Props>()
const { width } = useWindowSize()
const isMobile = computed(() => width.value < 768)
const { t } = useI18n()

const data = computed(() => store?.state.checkpoint?.data?.checkpoints)
const devices = computed(() => props.checkpoints?.flatMap(item => item.associates))

const devicesCount = computed(
    () =>
        devices.value?.reduce(
            (prev, current) =>
                (prev += current?.status && parseInt(current.status?.toString()) === 1 ? 1 : 0),
            0
        ) ?? 0
)

const checkpointCount = computed(() => ({
    label: t('event.detail.stats.checkpointsCount'),
    value: data.value?.length
}))
const onlineDevicesCount = computed(() => ({
    label: t('event.detail.stats.onlineDevicesCount'),
    value: `${devicesCount.value}/${devices.value?.length}`
}))
const eventReadsCount = computed(() => ({
    label: t('event.detail.stats.readsCount'),
    value: `${props.eventData?.detections_stats?.nb_detections}`
}))
</script>

<template>
    <StackLayout>
        <template v-if="!isMobile">
            <CheckpointStatTypography :data="checkpointCount" />
            <DividerItem :orientation="EOrientation.VERTICAL" />
        </template>
        <CheckpointStatTypography :data="onlineDevicesCount" />
        <DividerItem :orientation="EOrientation.VERTICAL" />
        <CheckpointStatTypography :data="eventReadsCount" />
    </StackLayout>
</template>

<style scoped lang="scss">
.checkpoint-section-content {
    overflow-y: scroll;
}

.checkpoints-list {
    padding: 1em;
}
</style>
